module.exports = __webpack_public_path__ + "static/img/11.d012d09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/11.jpg
// module id = CbL3
// module chunks = 1